"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const Stringify_1 = require("./Stringify");
exports.BadgeComponent = ({ type, child, className, col, colIndex, row, rowIndex, }) => {
    const id = `badge-cell-type-row-${rowIndex}-col-${colIndex}`;
    if (!child)
        return null;
    if (typeof child === "string" || typeof child === "number") {
        child = { text: child, tooltip: child };
    }
    if (typeof child === "object" &&
        Object.values(child).filter((x) => Boolean(x)).length === 0) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reactstrap_1.Badge, { className: `${className} d-block text-truncate`, color: type, tag: "div", id: id },
            react_1.default.createElement(Stringify_1.Stringify, { col: col, value: child.text })),
        child.tooltip && (react_1.default.createElement(reactstrap_1.UncontrolledTooltip, { target: id },
            react_1.default.createElement(Stringify_1.Stringify, { col: col, value: child.tooltip })))));
};
//# sourceMappingURL=Badge.js.map